import * as fromDatatype from "../datatype-library/index";


export interface bl_wms_picking_cart_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    qty_picked: fromDatatype.NumericDatatypeInterface;
    qty_to_pick: fromDatatype.NumericDatatypeInterface;
    picking_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_guid: fromDatatype.GuidDataFieldInterface;
    wms_item_guid: fromDatatype.GuidDataFieldInterface;
    layout_node_hdr_guid: fromDatatype.GuidDataFieldInterface;
    container_hdr_guid: fromDatatype.GuidDataFieldInterface;
    item_code: fromDatatype.VarcharDatatypeInterface;
    container_scan_code: fromDatatype.VarcharDatatypeInterface;
    container_code: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
    gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
}


export class bl_wms_picking_cart_RowClass
    implements bl_wms_picking_cart_RowInterface {
        guid: fromDatatype.GuidDataFieldInterface;
        qty_picked: fromDatatype.NumericDatatypeInterface;
        qty_to_pick: fromDatatype.NumericDatatypeInterface;
        picking_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
        fi_item_guid: fromDatatype.GuidDataFieldInterface;
        inv_item_guid: fromDatatype.GuidDataFieldInterface;
        wms_item_guid: fromDatatype.GuidDataFieldInterface;
        layout_node_hdr_guid: fromDatatype.GuidDataFieldInterface;
        container_hdr_guid: fromDatatype.GuidDataFieldInterface;
        item_code: fromDatatype.VarcharDatatypeInterface;
        container_scan_code: fromDatatype.VarcharDatatypeInterface;
        container_code: fromDatatype.VarcharDatatypeInterface;
        property_json: fromDatatype.JsonDatatypeInterface;
        namespace: fromDatatype.VarcharDatatypeInterface;
        acl_config: fromDatatype.JsonDatatypeInterface;
        acl_policy: fromDatatype.JsonDatatypeInterface;
        created_date: fromDatatype.TimestampTzDatatypeInterface;
        updated_date: fromDatatype.TimestampTzDatatypeInterface;
        created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        status: fromDatatype.StatusDataFieldInterface;
        revision: fromDatatype.GuidDataFieldInterface;
        vrsn: fromDatatype.VrsnDataFieldInterface;
        posting_status: fromDatatype.VarcharDatatypeInterface;
        gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
}